export enum ScopeType {
  PARTNER = 'PARTNER',
  REGION = 'REGION',
  DOMAIN = 'DOMAIN',
  COUNTRY = 'COUNTRY',
  TREATMENT_CENTER = 'TREATMENT_CENTER'
}
